import React from 'react'

// Audio
import soundOn from '../../audio/soundOn.wav';
import soundOff from '../../audio/soundOff.wav';

// Components
import Edit from './DialogContentTypes/Edit/Edit';
import Leaderboard from './DialogContentTypes/Leaderboard/Leaderboard';
import Stop from './DialogContentTypes/Stop/Stop.js';

// Card Types
import cardTypes from '../../cardTypes';

// Material UI Components
import { makeStyles, AppBar, Toolbar, Typography, Tooltip, Icon, Popover, Box, Zoom, Button, Dialog, DialogTitle, IconButton, Slider } from '@material-ui/core';

// Material UI Custom Component Style
const useStyles = makeStyles(theme => ({
    AppBar: {
        position: 'relative',
        zIndex: 10,
        background: theme.palette.background.default
    },
    Toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    [`@media (max-width: 375px)`]: {
        SetSize: {
            fontSize: [[theme.typography.pxToRem(20)], '!important'], 
        }
    },
    Icon: {
        width: '100%'
    },
    Orange: {
        color: '#F39C12'
    },
    Yellow: {
        color: '#F1C40F'
    },
    Teal: {
        color: '#1ABC9C'
    },
    Red: {
        color: '#E74C3C'
    },
    Button: {
        color: theme.palette.error.main
    },
    SliderBlue: {
        color: theme.palette.primary.main
    },
    SliderYellow: {
        color: theme.palette.secondary.main
    },
    SliderRed: {
        color: theme.palette.error.main
    },
    SoundButtonOn: {
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
        '&:hover' : {
            background: theme.palette.primary.dark,
            color: theme.palette.common.white,
        }
    },
    SoundButtonOff: {
        background: theme.palette.error.main,
        color: theme.palette.common.white,
        '&:hover' : {
            background: theme.palette.error.dark,
            color: theme.palette.common.white,
        }
    },
}));

export default function Header( { cardType, gameState, soundState, volume, prevVolume, leaderboard, handleGetSeconds, onClickToggleSound, onChangeHandleSliderChange, onClickSelectCard, onClickClearLeaderboard } ) {
    const Style = useStyles();

    // Audio
    const soundOnSound = new Audio(soundOn);
    const soundOffSound = new Audio(soundOff);

    // Volume
    const newVolume = volume === 0 ? prevVolume : volume;
    soundOnSound.volume = newVolume;
    soundOffSound.volume = newVolume;

    let [randomIcon, setRandomIcon] = React.useState(null);

    const [startTimer, setStartTimer] = React.useState(false);
    let [time, setTime] = React.useState(0);

    const random = Math.floor(Math.random() * Math.floor(15));

    React.useEffect(() => {
        let timerinterval;
        let iconinterval;
        const seconds = 5000;

        switch(gameState){
            case "":
                setStartTimer(false);
                setTime(0);

                iconinterval = setInterval(() => {
                    const newRandom = Math.floor(Math.random() * Math.floor(15));
                    setRandomIcon(() => {
                        return(
                            cardType === null 
                                ? `fas ${cardTypes[0].icons[newRandom]}`
                                    : cardType.title === "Brands"
                                        ? `fab ${cardType.icons[newRandom]}`
                                            : `fas ${cardType.icons[newRandom]}`
                    )})
                }, randomIcon === null ? 50 : seconds);

                break;
            case "Started":
                setTimeout(() => {
                    setStartTimer(true);
                }, 5000);

                clearInterval(iconinterval);
                break;
            case "Stopped":
                setTimeout(() => {
                    setStartTimer(false);
                    handleGetSeconds(time);
                }, 0);

                break;
            default:
                break;
        }

        if(startTimer === true){
            timerinterval = setInterval(() => {
                setTime(newTime => newTime + 1);
            }, 1000); 
        }else{
            clearInterval(timerinterval);
        }

        return () => {clearInterval(iconinterval); clearInterval(timerinterval);};
    }, [gameState, setRandomIcon, cardType, random, randomIcon, startTimer, setTime, time, handleGetSeconds]);

    // Popover
    const [anchorEl, setAnchorEl] = React.useState(null);

    // This method will open the Popup
    const handlePopoverClick = event => {
        setAnchorEl(event.currentTarget);
    };

    // This method will close the Popup
    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const openPopover = Boolean(anchorEl);
    const popoverID = openPopover ? 'Audio Popup' : undefined;

    // Slider
    const [sliderValue, setSliderValue] = React.useState(volume * 100);
    
    // This method will update the sliders value
    const handleSliderChange = (event, newValue) => {
        event.preventDefault();

        if(newValue === sliderValue){
            return
        }else{
            setSliderValue(newValue);
            onChangeHandleSliderChange(newValue);
        }
    }

    // Dialog
    const [openDialog, setOpenDialog] = React.useState(false);
    const [dialogType, setDialogType] = React.useState(null);

    // This method will open the dialog and set the dialog content to the type
    const handleClickDialogOpen = (type) => {
        setOpenDialog(true);
        setDialogType(type);
    };
    
    // This method will close the dialog 
    const handleDialogClose = () => {
        setOpenDialog(false);
        setRandomIcon(null);
    };

    return (
        <React.Fragment>
            <AppBar className={Style.AppBar} color="transparent" position="static" variant="outlined" square>
                <Toolbar className={Style.Toolbar}>
                    {
                        gameState === "Started" || gameState === "Stopped"
                            ? 
                            <Typography color="primary" variant="h6">{time}<span>s</span></Typography>
                                :
                                <Toolbar disableGutters>
                                    <Tooltip title="Change Card Type" placement="right">
                                        <span>
                                            <IconButton aria-label="Change Card Type" color="primary" variant="text" edge="start" onClick={() => handleClickDialogOpen("Edit")}>
                                                <i className={`${randomIcon} ${Style.SetSize}`} style={{width: '1.125em'}}  />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <IconButton aria-label="Hidden" color="inherit" variant="text" edge="end" style={{visibility: 'hidden'}}>
                                        <Icon className={`${Style.Icon} ${Style.SetSize} fas fa-volume-up`} />
                                    </IconButton>
                                </Toolbar>
                    }
                    <Typography variant="body1" style={{textTransform: 'uppercase', fontWeight: 'bold'}}>
                        <span className={Style.Orange}>Con</span>
                        <span className={Style.Yellow}>cen</span>
                        <span className={Style.Teal}>tra</span>
                        <span className={Style.Red}>tion</span>
                    </Typography>
                    {
                        gameState === "Started" || gameState === "Stopped"
                            ? 
                            <Tooltip title="Stop Game" placement="left">
                                <IconButton className={Style.Button} aria-label="Stop Game" variant="text" edge="end" onClick={() => handleClickDialogOpen("Stop")}>
                                    <Icon className={`${Style.Icon} ${Style.SetSize} fas fa-ban`} />
                                </IconButton>
                            </Tooltip>
                                :
                                <Toolbar disableGutters>
                                    <Tooltip title="Leaderboard" placement="left">
                                        <span>
                                            <IconButton  aria-label="Leaderboard" color="secondary" variant="text" edge="start" onClick={() => handleClickDialogOpen("Leaderboard")} disabled={leaderboard.length <= 0 ? true : false}>
                                                <Icon className={`${Style.Icon} ${Style.SetSize} fas fa-trophy`} />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Tooltip title="Audio" placement="bottom">
                                        <IconButton 
                                            aria-label="Audio" 
                                            color="inherit" 
                                            variant="text" 
                                            edge="end" 
                                            className={soundState === false ? "" : (sliderValue >= 0 && sliderValue <= 40) ? Style.SliderBlue : (sliderValue >= 40 && sliderValue <= 70) ? Style.SliderYellow : Style.SliderRed }
                                            onClick={handlePopoverClick}
                                        >
                                            <i className={
                                                soundState === true && sliderValue >= 70
                                                    ? `${Style.Icon} ${Style.SetSize} fas fa-volume-up`
                                                        : soundState === true && sliderValue <= 70 && sliderValue > 0
                                                            ? `${Style.Icon} ${Style.SetSize} fas fa-volume-down`
                                                                : soundState === true && sliderValue === 0
                                                                    ? `${Style.Icon} ${Style.SetSize} fas fa-volume-off`
                                                                        : `${Style.Icon} ${Style.SetSize} fas fa-volume-mute`
                                                } 
                                                style={{width: '1.125em'}} />
                                        </IconButton>
                                    </Tooltip>
                                </Toolbar>
                    }
                </Toolbar>
            </AppBar>
            <Popover
                id={popoverID}
                open={openPopover}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                elevation={2}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                    transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                TransitionComponent={Zoom}
                transitionDuration={500}
            >
                <Box m={2}>
                    <Box style={{width: '250px'}}>
                        <Typography id="volumeSlider" variant="button" gutterBottom>
                            Volume
                        </Typography>
                        <Slider 
                            aria-labelledby="volumeSlider"
                            value={sliderValue}
                            valueLabelDisplay="on"
                            step={10} 
                            marks
                            onChange={handleSliderChange}
                            disabled={soundState === true ? false : true}
                            className={(sliderValue >= 0 && sliderValue <= 40) ? Style.SliderBlue : (sliderValue >= 40 && sliderValue <= 70) ? Style.SliderYellow : Style.SliderRed }
                        />
                    </Box>
                    <Button 
                        className={soundState === true ? Style.SoundButtonOff : Style.SoundButtonOn} 
                        variant="contained" 
                        onMouseDown={() => {soundState === true ? soundOffSound.play() : soundOnSound.play()}} 
                        onClick={soundState === true ? () => onClickToggleSound("Off") : () => onClickToggleSound("On")} fullWidth>
                        {
                            soundState === true 
                                ? "Sound Off"
                                    : "Sound On"
                        }
                    </Button>
                </Box>
            </Popover>
            <Dialog
                open={openDialog}
                onClose={handleDialogClose}
                aria-labelledby="dialogTitle"
            >
                <DialogTitle id="dialogTitle">
                    {
                        dialogType === "Edit" 
                            ? "Change Card Type"
                                : dialogType === "Leaderboard" 
                                    ? "Leaderboard"
                                        : dialogType === "Stop" 
                                            ? "Stop Game"
                                                : ""
                    }
                </DialogTitle>
                {
                    dialogType === "Edit" 
                        ? <Edit cardType={cardType} cardTypes={cardTypes} random={Math.floor(Math.random() * Math.floor(9))} onClickSelectCard={onClickSelectCard} handleDialogClose={handleDialogClose} />
                            : dialogType === "Leaderboard" 
                                ? <Leaderboard leaderboard={leaderboard} handleDialogClose={handleDialogClose} onClickClearLeaderboard={onClickClearLeaderboard} />
                                    : dialogType === "Stop" 
                                        ? <Stop leaderboard={leaderboard} handleDialogClose={handleDialogClose} onClickClearLeaderboard={onClickClearLeaderboard} />
                                            : ""
                }
            </Dialog>
        </React.Fragment>
    )
}
